export default __webpack_public_path__ + "static/media/cross-icon.adf48e64.svg";